/**
 * Globo form helpers:
 * 1. Cap z-index of Globo overlays so they stay below the site header/mega menu.
 *    Globo sets inline `style="z-index: 99999"` (sometimes with !important) via JS,
 *    which beats theme CSS. A MutationObserver watches for any globo/gfb element
 *    being added or having its style changed, and clamps its z-index to 90 — the
 *    theme header (--header-z-index = 10^22) sits safely on top.
 * 2. Lock body scroll while a Globo popup form is open (`.popup-layout.active`),
 *    restore when closed.
 */
(function () {
  'use strict';

  var MAX_Z = 90;
  var SELECTOR = '.globo-form-app,.globo-formbuilder,.g-container,.floating-button,.floating-form-wrapper,[class*="globo-form-floating"],[class*="gfb__floating"],[class*="gfb-floating"],[class*="globo-modal"],[class*="gfb-modal"],[class*="gfb-popup"]';
  var POPUP_SELECTOR = '.globo-form-app.popup-layout.active';
  var SCROLL_LOCK_CLASS = 'globo-popup-scroll-lock';

  function capNode(el) {
    if (!el || el.nodeType !== 1) return;
    el.style.setProperty('z-index', String(MAX_Z), 'important');
  }

  function capAll() {
    document.querySelectorAll(SELECTOR).forEach(capNode);
  }

  function syncScrollLock() {
    var popupOpen = !!document.querySelector(POPUP_SELECTOR);
    document.documentElement.classList.toggle(SCROLL_LOCK_CLASS, popupOpen);
    document.body.classList.toggle(SCROLL_LOCK_CLASS, popupOpen);
  }

  function run() {
    capAll();
    syncScrollLock();
    var observer = new MutationObserver(function (mutations) {
      var shouldSync = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(SELECTOR)) capNode(node);
            if (node.querySelectorAll) node.querySelectorAll(SELECTOR).forEach(capNode);
          });
          shouldSync = true;
        } else if (m.type === 'attributes' && m.target) {
          if (m.target.matches && m.target.matches(SELECTOR)) capNode(m.target);
          if (m.attributeName === 'class') shouldSync = true;
        }
      }
      if (shouldSync) syncScrollLock();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
